"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_MISSING_CODE = void 0;
exports.changeLanguage = changeLanguage;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
var _ensureEndsWith = require("./ensureEndsWith");
var _getLanguageCodeAbbreviation = require("./getLanguageCodeAbbreviation");
var _getLegacyCookieName = require("./getLegacyCookieName");
var _isDefaultLanguage = require("./isDefaultLanguage");
const ensureEndsWithSlash = value => (0, _ensureEndsWith.ensureEndsWith)(value, '/');
const ERROR_MISSING_CODE = exports.ERROR_MISSING_CODE = 'Cannot change to new language as it has missing code';
/**
 * Changes language to provided value by saving it to cookies and redirecting to appropriate URL, if needed.
 *
 * @param nextLanguage
 * @param currentLanguage
 * @param tenant
 */
// eslint-disable-next-line max-params -- Nope
function changeLanguage(nextLanguage, currentLanguage, tenant,
/**
 * If pathname should be changed to new language, if false then only cookies are changed
 */
changePath = true) {
  const legacyCookieName = (0, _getLegacyCookieName.getLegacyCookieName)(tenant);
  if (!nextLanguage.code) {
    throw new Error(ERROR_MISSING_CODE);
  }
  _jsCookie.default.set(_constants.LANGUAGE_COOKIE_KEY, nextLanguage.code, _constants.LANGUAGE_COOKIE_OPTIONS);
  // Set also an older Online cookie to make this compatible on older pages.
  _jsCookie.default.set(legacyCookieName, nextLanguage.code, _constants.LANGUAGE_COOKIE_OPTIONS);
  if (changePath) {
    // Get language code abbreviation by removing the 2nd country part.
    const languageCodeAbbrev = (0, _getLanguageCodeAbbreviation.getLanguageCodeAbbreviation)(nextLanguage.code);

    // Create a new pathname from current pathname and ensure that it ends with slash
    let newPathName = ensureEndsWithSlash(window.location.pathname);

    // Remove current language from pathname, if any.
    newPathName = newPathName.replace(new RegExp(`^/${(0, _getLanguageCodeAbbreviation.getLanguageCodeAbbreviation)(currentLanguage)}/`), '/');

    // If a selected language is not the default one, add its abbrev to the start of pathname.
    if (!(0, _isDefaultLanguage.isDefaultLanguage)(nextLanguage)) {
      newPathName = `/${languageCodeAbbrev}${newPathName || '/'}`;
    }

    // Reload page and make sure that it ends with slash again
    window.location.pathname = ensureEndsWithSlash(newPathName);
  }
}